import React from "react";
import {
  Label,
  Input,
  FormFeedback,
  Row,
  Col,
  CardBody,
  Card,
  Button,
} from "reactstrap";

interface PostalAddressInputProps {
  validation: any; // Replace 'any' with the appropriate type for the 'validation' parameter
}

const PostalAddressInput = ({ validation }: PostalAddressInputProps) => {
  return (
    <>
      {validation.values.postalAddress.map(
        (postalAddress: any, index: number) => {
          return (
            <Card className="bg-light" key={index}>
              <CardBody>
                <Row>
                  <Col md={12} className="mb-3">
                    <Label htmlFor={`address-${index}`} className="form-label">
                      Address
                    </Label>
                    <Input
                      name={`postalAddress[${index}].address`}
                      id={`address-${index}`}
                      className="form-control"
                      placeholder="Enter postal address"
                      type="textarea"
                      validate={{ required: { value: true } }}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={postalAddress.address || ""}
                      invalid={
                        validation.touched.postalAddress?.[index]?.address &&
                        validation.errors.postalAddress?.[index]?.address
                          ? true
                          : false
                      }
                    />
                    {validation.touched.postalAddress?.[index]?.address &&
                      validation.errors.postalAddress?.[index]?.address && (
                        <FormFeedback type="invalid">
                          {validation.errors.postalAddress?.[index]?.address}
                        </FormFeedback>
                      )}
                  </Col>
                  <Col md={6} className="mb-3">
                    <Label htmlFor={`city-${index}`} className="form-label">
                      City
                    </Label>
                    <Input
                      name={`postalAddress[${index}].city`}
                      id={`city-${index}`}
                      className="form-control"
                      placeholder="Enter city"
                      type="text"
                      validate={{ required: { value: true }, email: true }}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={postalAddress.city || ""}
                      invalid={
                        validation.touched.postalAddress?.[index]?.city &&
                        validation.errors.postalAddress?.[index]?.city
                          ? true
                          : false
                      }
                    />
                    {validation.touched.postalAddress?.[index]?.city &&
                      validation.errors.postalAddress?.[index]?.city && (
                        <FormFeedback>
                          {validation.errors.postalAddress[index].city}
                        </FormFeedback>
                      )}
                  </Col>
                  <Col md={6} className="mb-3">
                    <Label htmlFor={`country-${index}`} className="form-label">
                      Country
                    </Label>
                    <Input
                      name={`postalAddress[${index}].country`}
                      id={`country-${index}`}
                      className="form-control"
                      placeholder="Enter country"
                      type="text"
                      validate={{ required: { value: true } }}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={postalAddress.country || ""}
                      invalid={
                        validation.touched.postalAddress?.[index]?.country &&
                        validation.errors.postalAddress?.[index]?.country
                          ? true
                          : false
                      }
                    />
                    {validation.touched.postalAddress?.[index]?.country &&
                      validation.errors.postalAddress?.[index]?.country && (
                        <FormFeedback>
                          {validation.errors.postalAddress[index].country}
                        </FormFeedback>
                      )}
                  </Col>

                  <div className="mb-0 d-flex justify-content-end">
                    <Button
                      className="btn btn-sm btn-soft-danger waves-effect waves-light material-shadow-none"
                      onClick={() => {
                        validation.setFieldValue(
                          "postalAddress",
                          validation.values.postalAddress.filter(
                            (_: any, postalAddressIndex: number) =>
                              postalAddressIndex !== index
                          )
                        );
                      }}
                    >
                      {/* <i className="ri-delete-bin-fill me-2"></i> */}
                      Remove
                    </Button>
                  </div>
                </Row>
              </CardBody>
            </Card>
          );
        }
      )}

      <button
        className="btn btn-soft-secondary  waves-effect waves-light material-shadow-none"
        disabled={validation.values.postalAddress.length === 3}
        onClick={(e) => {
          e.preventDefault();
          if (validation.values.postalAddress.length < 3) {
            const newPostalAddress = {
              address: "",
              city: "",
              country: "",
            };
            validation.setFieldValue("postalAddress", [
              ...validation.values.postalAddress,
              newPostalAddress,
            ]);
          }
        }}
      >
        Add
      </button>
    </>
  );
};

export default PostalAddressInput;
